import { __assign } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import { useFormContext, useController } from 'react-hook-form';
import Tick from '../../../atoms/Icons/Tick/Tick.js';
import { FormHint } from '../Form.styles.js';
import { Checkbox, CheckboxLabel, CheckboxInner, CheckboxIndicator } from './CheckboxInput.styles.js';

var CheckboxInput = function (_a) {
    var name = _a.name, label = _a.label, _b = _a.showError, showError = _b === void 0 ? true : _b, children = _a.children, disabled = _a.disabled, _c = _a.size, size = _c === void 0 ? "s" : _c, _d = _a.type, type = _d === void 0 ? "default" : _d, className = _a.className, onCheckedChange = _a.onCheckedChange;
    var setValue = useFormContext().setValue;
    var _e = useController({
        name: name,
    }), field = _e.field, fieldState = _e.fieldState;
    if (!label && !children)
        return null;
    return (React.createElement(Checkbox, { className: className },
        React.createElement(CheckboxLabel, { htmlFor: name, className: "styled-label", "aria-label": name, disabled: disabled },
            React.createElement(CheckboxInner, __assign({}, field, { hasError: Boolean(fieldState.error), checked: field.value, disabled: disabled, id: name, size: size, checkboxType: type, onCheckedChange: function () {
                    // We want to use this with radix so we need to set the value manually
                    // @ts-expect-error but it doesn't know the type of the provided schema throwing the a type error
                    setValue(name, !field.value, { shouldValidate: true });
                    if (onCheckedChange) {
                        onCheckedChange(!field.value);
                    }
                } }),
                React.createElement(CheckboxIndicator, __assign({ size: size, checked: field.value, disabled: disabled, checkboxType: type }, (type === "box" ? { forceMount: true } : {})), type === "box" ? children || label : React.createElement(Tick, null))),
            type !== "box" && (children || label)),
        fieldState.error && showError && (React.createElement(FormHint, { error: true }, fieldState.error.message))));
};

export { CheckboxInput };
//# sourceMappingURL=CheckboxInput.js.map
